import React from 'react';

const Whatsapp = () => {
  return (
    <svg
      width="39px"
      height="39px"
      viewBox="0 0 39 39"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Ecran-2---impayé-Copy"
          transform="translate(-274.000000, -593.000000)"
          fill="#E84249"
          fillRule="nonzero"
        >
          <g id="Widget" transform="translate(0.000000, 556.000000)">
            <g id="Icon" transform="translate(47.000000, 30.000000)">
              <g id="whatsapp" transform="translate(227.000000, 7.000000)">
                <path
                  d="M33.3177576,5.66766354 C29.6515821,2.01474609 24.7758651,0.00214233094 19.5815583,0 C8.8781818,0 0.167187953,8.6690735 0.162882654,19.3240906 C0.161447595,22.7301635 1.05550838,26.0550659 2.75489369,28.9857788 L0,39 L10.2941369,36.3125611 C13.1305914,37.8524231 16.323905,38.6638916 19.5736654,38.6648437 L19.5817976,38.6648437 C30.2839782,38.6648437 38.9959288,29.9950561 39,19.339563 C39.0021475,14.1755859 36.9841723,9.32034303 33.3177576,5.66766354 Z M19.5815583,35.4011169 L19.5748612,35.4011169 C16.6788504,35.3999268 13.8385689,34.625354 11.3601692,33.1621399 L10.7710649,32.8138916 L4.6623669,34.4087402 L6.29286791,28.4813782 L5.90898139,27.8736694 C4.29330974,25.3161987 3.44014896,22.3602539 3.44158221,19.3252807 C3.44493259,10.4691101 10.685438,3.26396484 19.5880163,3.26396484 C23.8990254,3.2653931 27.9514792,4.93831784 30.9986528,7.97448119 C34.0458264,11.0106445 35.7229678,15.0463257 35.7215336,19.3383728 C35.7177057,28.1952576 28.4776788,35.4011169 19.5815583,35.4011169 L19.5815583,35.4011169 Z M28.4346261,23.3709595 C27.9495658,23.1291138 25.5639685,21.9613037 25.1190907,21.7999146 C24.6746913,21.6387634 24.3508394,21.5585449 24.0277051,22.0417603 C23.7040924,22.5249756 22.7743935,23.6128052 22.4912025,23.9348694 C22.2080115,24.2571716 21.9252988,24.297638 21.4399994,24.0557923 C20.9546999,23.8141846 19.3914089,23.304071 17.5379907,21.6589966 C16.0957257,20.378595 15.1220174,18.7973145 14.8388264,18.3140991 C14.5561137,17.8304077 14.8364346,17.5942749 15.051698,17.3286255 C15.5769409,16.6794983 16.1029012,15.9989502 16.2645879,15.676886 C16.4265139,15.3545837 16.3454313,15.0725098 16.2239271,14.8309021 C16.1029012,14.5892944 15.1325414,12.2124939 14.7283245,11.2453491 C14.3341532,10.3041504 13.9344808,10.4312622 13.6364605,10.4165039 C13.3537479,10.4024597 13.0301352,10.3996033 12.7065224,10.3996033 C12.3831489,10.3996033 11.8574278,10.5202881 11.41255,11.0039795 C10.9679114,11.4874329 9.71459984,12.655481 9.71459984,15.0322815 C9.71459984,17.409082 11.4532109,19.705188 11.695741,20.0274902 C11.9382711,20.3497925 15.1172338,25.2271729 19.9843401,27.3185669 C21.1419791,27.8165405 22.0456072,28.1133728 22.7504754,28.3359375 C23.9128979,28.7034668 24.9703198,28.6515747 25.8064987,28.5273193 C26.7388285,28.3885437 28.676917,27.3590332 29.0816123,26.2312134 C29.4858292,25.1031555 29.4858292,24.1364868 29.3643249,23.9348694 C29.2432991,23.73349 28.9196864,23.6128052 28.4346261,23.3709595 L28.4346261,23.3709595 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Whatsapp;
